import { Row, Col } from 'react-bootstrap';
import { FieldWrapper, RadioFieldGroup } from 'components/form';
import { QuestionnaireNextButton } from 'components/questionnaire-next-button';
import { InfoBox } from 'components/info-box';

import { QuestionContainer, QuestionContainerWhite, QuestionNumber } from '../../../components/styles';
import { useFormContext } from 'react-hook-form';

import questions from '../../../utils/MOT-questions-answers.json';
import popupTextData from '../../../utils/midlife-mot-info-pop-up-text.json';

export const QuestionOne = () => {
    const { data } = popupTextData;
    const popupText = data.find(item => item.question === 'wellbeing_question1');

    const { data: questionsData } = questions;
    const question = questionsData.find(item => item.question === '1');

    const options = questionsData.map((item: any) => {
        const options = [];
        for (let i = 1; i <= 5; i++) {
            const label = item[`answerValue${i}`];
            const value = item[`answerLabel${i}`];
            if (label && value) {
                options.push({ label, value });
            }
        }
        return options.reverse();
    });

    const {
        control,
        formState: { dirtyFields },
    } = useFormContext();

    return (
        <>
            <QuestionContainer>
                <Row>
                    <Col>
                        <QuestionNumber>Question 1 of 18</QuestionNumber>
                    </Col>
                </Row>
            </QuestionContainer>

            <QuestionContainerWhite>
                <QuestionContainer>
                    <Row>
                        <Col>
                            <FieldWrapper label={question!.questionText}>
                                <InfoBox content={popupText!.QuestionInfoButtonText} />
                                <RadioFieldGroup stacked name="wellbeing1" options={options[0]} />
                            </FieldWrapper>

                            <Row className="justify-content-end flex-column flex-md-row" style={{ marginTop: 25 }}>
                                <QuestionnaireNextButton
                                    defaultValue={control._defaultValues.wellbeing1}
                                    dirtyFields={dirtyFields.wellbeing1}
                                    route={'/question-two'}
                                />
                            </Row>
                        </Col>
                    </Row>
                </QuestionContainer>
            </QuestionContainerWhite>
        </>
    );
};
